import { render } from "./QueueTimelineElement.vue?vue&type=template&id=313bc3f4&scoped=true&ts=true"
import script from "./QueueTimelineElement.vue?vue&type=script&lang=ts"
export * from "./QueueTimelineElement.vue?vue&type=script&lang=ts"

import "./QueueTimelineElement.vue?vue&type=style&index=0&id=313bc3f4&scoped=true&lang=scss"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313bc3f4"]])

export default __exports__